export default __webpack_public_path__ + "static/media/video-3.018438db.png";